import clsx from 'clsx';
import styles from './ImageView.module.scss';

function ImageView({
  src,
  alt,
  isFreeSize = false,
  isCircled = false,
  style,
  loading = 'lazy',
  objectFit = 'cover',
}: {
  src?: string;
  alt?: string;
  isFreeSize?: boolean;
  isCircled?: boolean;
  style?: React.CSSProperties;
  loading?: 'eager' | 'lazy';
  objectFit?: 'cover' | 'contain';
}) {
  const imgClasses = clsx({
    [styles.isFreeSize]: isFreeSize,
    [styles.defaultSize]: !isFreeSize,
    [styles.isCircled]: isCircled,
    [styles.objectFitCover]: objectFit === 'cover',
    [styles.objectFitContain]: objectFit === 'contain',
  });
  return (
    <div className={`${styles.componentStyle}`} style={style}>
      <img src={src} alt={alt} loading={loading} className={imgClasses} />
    </div>
  );
}

export default ImageView;
